/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Thumbs } from 'swiper/core';
import { useMediaQuery } from 'react-responsive';
import { VehicleImages } from '../../types';
import ChevronRightIcon from '../../assets/icons/RightChevron';
import ChevronLeftIcon from '../../assets/icons/LeftChevron';
import { LeftChevronWrap, RightChevronWrap, SwiperContainer } from './styles/Slider.style';

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation, Thumbs]);

interface SliderProps {
  images?: VehicleImages[] | undefined;
  nonAudiImages?: string[] | null;
  modelName: string;
  isUsed: boolean;
  nonAudi: boolean;
}

const Slider: React.FC<SliderProps> = ({ images, modelName, isUsed, nonAudi, nonAudiImages }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const isLargeScreen = useMediaQuery({
    query: '(min-width: 1100px)',
  });

  const slidesPerView = isLargeScreen ? 5 : 4;
  let slides;
  let thumbs;
  if (!nonAudi && !isUsed) {
    // is new vehicle
    slides = images?.map((image, i) => {
      const imageUrl = typeof image !== 'object' && (isUsed || nonAudi) ? image : image.url;
      return (
        <SwiperSlide tag="li" key={`${i}-slide`}>
          <img src={isLargeScreen ? imageUrl : `${imageUrl}?wid=1000`} alt={`${modelName}-${i}`} />
        </SwiperSlide>
      );
    });
    thumbs = images?.map((image, i) => {
      const imageUrl = typeof image !== 'object' && (isUsed || nonAudi) ? image : image.url;
      return (
        <SwiperSlide tag="li" key={`${i}-thumbnail`}>
          <img src={`${imageUrl}?wid=300`} alt={`${modelName}-${i}-thumbnail`} />
        </SwiperSlide>
      );
    });
  } else {
    // is a used or non-audi vehicle
    slides = nonAudiImages?.map((img, i) => {
      return (
        <SwiperSlide tag="li" key={`${i}-slide`}>
          <img src={img} alt={`${modelName}-${i}`} />
        </SwiperSlide>
      );
    });
    thumbs = nonAudiImages?.map((img, i) => {
      return (
        <SwiperSlide tag="li" key={`${i}-thumbnail`}>
          <img src={img} alt={`${modelName}-${i}-thumbnail`} />
        </SwiperSlide>
      );
    });
  }

  return (
    <SwiperContainer isUsed={isUsed} data-testid="swiper-slide-container">
      <SwiperSlide>
        <LeftChevronWrap className="swiper-button-prev">
          <ChevronLeftIcon />
        </LeftChevronWrap>
        <Swiper
          thumbs={{ swiper: thumbsSwiper }}
          className="mySwiper2"
          wrapperTag="ul"
          freeMode={false}
          allowTouchMove={false}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
        >
          {slides}
        </Swiper>
        <Swiper
          // Todo External onSwipper TS issue
          // @ts-ignore
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={slidesPerView}
          freeMode={false}
          watchSlidesVisibility
          watchOverflow
          threshold={0}
          watchSlidesProgress
          className="mySwiper"
          allowTouchMove={false}
        >
          {thumbs}
        </Swiper>
        <RightChevronWrap className="swiper-button-next">
          <ChevronRightIcon />
        </RightChevronWrap>
      </SwiperSlide>
    </SwiperContainer>
  );
};

export default Slider;
